import * as Factory from 'factory.ts'
import faker from 'faker'

import { PaymentMethodTypes } from '@webapp/models/enums'
import { type PaymentV2Simple } from '@webapp/models/PaymentV2Simple'
import { PaymentStatuses } from '@webapp/modules/payments'

export const PaymentV2SimpleMock = Factory.Sync.makeFactory<PaymentV2Simple>({
  id: Factory.each(() => faker.random.number()),
  uuid: Factory.each(() => faker.random.uuid()),
  user: Factory.each(() => faker.random.number()),
  approver: Factory.each(() => faker.random.number()),
  currency: Factory.each(() => faker.random.number()),
  amount: Factory.each(() => faker.finance.amount()),
  payment_method: PaymentMethodTypes.ACH,
  payment_date: Factory.each(() => faker.date.future().toISOString()),
  processing_date: null,
  memo: Factory.each(() => faker.random.words()),
  reference_number: Factory.each(() => faker.random.uuid()),
  is_processed: false,
  status: PaymentStatuses.APPROVED,
})
